import { Schedule } from "../../../../types/schedule/schedule";
import { ScheduleState } from "../../../type/schedule-state";

interface Action {
  type: string;
  payload: {
    selectedSchedule: Schedule;
  };
}

export const setSelectedScheduleDispatch = (
  state: ScheduleState,
  action: Action
) => {
  const { selectedSchedule } = action.payload;
  state.selectedSchedule = selectedSchedule;
};
